export default __webpack_public_path__ + "static/applet-13-set-1-1d336ec64872013750c42a505710bfd2.webp";